import React, { type PropsWithChildren, useEffect, useRef, useState } from 'react';

import invariant from 'tiny-invariant';

import { GroupDropIndicator as AkGroupDropIndicator } from '@atlaskit/navigation-system/side-nav-items/drag-and-drop/group-drop-indicator';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

import { useOptions } from '../../../controllers/options-context';
import { isL1ItemData } from '../../utils/dnd-data';

export function GroupDropIndicator({ children }: PropsWithChildren) {
	const { l1DragAndDropEnabled } = useOptions();

	const l1GroupDropIndicatorRef = useRef<HTMLDivElement | null>(null);
	const [l1DragState, setL1DragState] = useState<'idle' | 'is-over'>('idle');
	useEffect(() => {
		if (!l1DragAndDropEnabled) {
			return;
		}

		const l1GroupDropIndicator = l1GroupDropIndicatorRef.current;
		invariant(l1GroupDropIndicator, 'l1GroupDropIndicatorRef should not be null');
		return dropTargetForElements({
			element: l1GroupDropIndicator,
			canDrop: ({ source }) => isL1ItemData(source.data),
			onDragStart() {
				setL1DragState('is-over');
			},
			onDragEnter() {
				setL1DragState('is-over');
			},
			onDragLeave() {
				setL1DragState('idle');
			},
			onDrop() {
				setL1DragState('idle');
			},
		});
	}, [l1DragAndDropEnabled]);

	if (!l1DragAndDropEnabled) {
		return <>{children}</>;
	}

	return (
		<AkGroupDropIndicator ref={l1GroupDropIndicatorRef} isActive={l1DragState === 'is-over'}>
			{children}
		</AkGroupDropIndicator>
	);
}
